import { useContext } from "react";

import { MyLearningContext } from "./provider";

export const useMyLearning = () => {
  const context = useContext(MyLearningContext);
  if (context === undefined) {
    throw new Error("useMyLearning must be used within a MyLearningProvider");
  }
  return context;
};
